import UserProfileShimmer from './UserProfileShimmer';

export default UserProfileShimmer;
